module.exports = "/_next/static/images/ai-expreg-demo4-e5140080ac8e3a7061a9ba7a05e26f83.jpg";